<template>
    <div class="cart" :class="{ 'as-fullwidth': isPlan, 'has-alert': hasAlert }">
        <section class="cart-config">
            <div class="flex-column cart-config-back ovy-reset mb-7">
                <a
                    href="/home"
                    class="block"
                    :title="$t.__('pages.account.CartTemplate.home_page')"
                >
                    <SaasIcon
                        icon="svgLogoSellsyText"
                        width="118"
                        height="28"
                        class="m-0 mb-2 secondary-blue"
                    />
                </a>
                <CompassBackForwardButton
                    v-if="canBack"
                    :label="$t.__('common.actions.back')"
                    :link="buildUrlClient"
                    back
                />
            </div>

            <!-- Select/Config/Payement panel -->
            <slot name="configuration">config</slot>
        </section>

        <!-- Recap panel of the bill -->
        <section
            v-if="!isPlan"
            class="cart-recap zi-2"
            :class="advCheck ? 'primary-05-bkg' : 'gray-0-bkg'"
        >
            <adv-authorization v-if="advCheck"></adv-authorization>
            <slot v-else name="resume">resume</slot>
        </section>
    </div>
</template>

<script>
import AdvAuthorization from 'vcomponents/pages/account/upsell/AdvAuthorization.vue';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
        AdvAuthorization,
    },
    props: {
        isPlan: {
            type: Boolean,
            required: false,
            default: false,
        },
        canBack: {
            type: Boolean,
            required: false,
            default: true,
        },
        hasAlert: {
            type: Boolean,
            required: false,
            default: false,
        },
        advCheck: {
            type: Boolean,
            required: false,
            default: false,
        },
        isSales: {
            type: Boolean,
            required: false,
            default: false,
        },
        customer: {
            type: Object,
            required: false,
        },
    },
    computed: {
        buildUrlClient() {
            return this.isSales
                ? '/thirds/' + this.customer.type + '/' + this.customer.id
                : '/home';
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.cart {
    display: grid;
    margin: -32px -32px auto;
    grid-template-columns: auto 500px;
    min-height: 100%;
    padding: 0;

    &.as-fullwidth {
        grid-template-columns: 100%;

        &.has-alert {
            &:before {
                top: 28.2rem;
            }
        }

        &:before {
            overflow: hidden;
            content: '';
            left: 0;
            background: $secondary-grey;
            position: absolute;
            width: 100%;
            height: 85.5rem; // NEW
            // height: 84.2rem;
            top: 24rem;
            z-index: 0;
        }

        .cart-config {
            margin: 0 auto;
            max-width: 1120px;
            padding: 0;
            width: 100%;
        }
    }

    .el-form-item__label {
        font-weight: $font-weight-semibold;
    }

    .separator {
        height: 1px;
        width: 100%;
        background-color: $gray-40;
    }

    .el-input {
        &.is-disabled {
            .el-input__inner {
                border: 1px solid $gray-40;
                background-color: $gray-05;
            }
        }
    }
}

.cart-config-back {
    margin-left: -115px;
    a {
        width: fit-content;
    }
}

.cart-config {
    max-width: 620px;
    width: 100%;
    margin: 0 auto;
    padding: 40px 0;

    .cart-config-title {
        font-size: 32px;
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: auto;
    }
}

.cart-recap {
    bottom: 0;
    line-height: 20px;
    position: fixed;
    right: 0;
    top: 0;
    width: 500px;
    > div {
        height: 100%;
        position: relative;
    }
}

@media screen and (max-width: 1200px) {
    body[class^='page-sam-v4'] .global {
        min-width: 450px;
        overflow-x: scroll;
    }

    .cart {
        display: block;
    }

    .cart-recap {
        position: relative;
        top: unset;
        right: unset;
        bottom: unset;
        left: unset;
        width: 100%;

        & > div {
            height: auto;
        }
    }

    .cart-config-back {
        margin-left: 0;
    }
}

@media screen and (max-width: 620px) {
    .cart-config {
        padding: 0 10px;
    }

    .cart-recap > div {
        padding: 24px !important;
    }
}
</style>
